import {

	Blog1BlogImg1,
	Blog1BlogImg2,
	Blog1BlogImg3

} from '../../utils/allImgs'


const data = [
	{
		img:Blog1BlogImg1,
		name:"Nazrul",
		hist:"Apr 10, 2021",
		numCom:"7 comments",
		title:"New and Creative NFTs Marketplace for All Digital Asset Needs.",
		text:"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus fugiat at vitae, ratione sapiente repellat."
	},
	{
		img:Blog1BlogImg2,
		name:"Nazrul",
		hist:"Apr 10, 2021",
		numCom:"7 comments",
		title:"Holly Herndon and Mat Dryhurst on the dreamy decentralized collaboration.",
		text:"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus fugiat at vitae, ratione sapiente repellat."
	},
	{
		img:Blog1BlogImg3,
		name:"Nazrul",
		hist:"Apr 10, 2021",
		numCom:"7 comments",
		title:"Rick Silva on the nature of a not-too-distant future.",
		text:"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus fugiat at vitae, ratione sapiente repellat."
	},
	{
		img:Blog1BlogImg1,
		name:"Nazrul",
		hist:"Apr 10, 2021",
		numCom:"7 comments",
		title:"NFT’s smart contracts are verified and open source.",
		text:"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus fugiat at vitae, ratione sapiente repellat."
	},
	{
		img:Blog1BlogImg2,
		name:"Nazrul",
		hist:"Apr 10, 2021",
		numCom:"7 comments",
		title:"Manual Photo + Raven B. on picturing a whole new world.",
		text:"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus fugiat at vitae, ratione sapiente repellat."
	},
	{
		img:Blog1BlogImg3,
		name:"Nazrul",
		hist:"Apr 10, 2021",
		numCom:"7 comments",
		title:"Guest Blog: Gene Kogan on the art of credit assignment.",
		text:"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus fugiat at vitae, ratione sapiente repellat."
	}
]


export default data